import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';


export const LicenseInformationSkeleton = () => (
    <FormSection
        headline="Active License"
        info={() => (
            <Item grow={1}>
                <Group>
                    <SkeletonItem width={73} height={28}/>
                    <SkeletonItem width={73} height={28}/>
                    <SkeletonItem width={73} height={28}/>
                </Group>
            </Item>
        )}>
        <Group direction="v" gap="m">
            <Group gap="xl">
                <Item style={{width: 120}}>
                    <SkeletonItem width={90} height={18}/>
                </Item>
                <SkeletonItem width={160} height={18}/>
            </Group>
            <Group gap="xl">
                <Item style={{width: 120}}>
                    <SkeletonItem width={90} height={18}/>
                </Item>
                <SkeletonItem width={160} height={18}/>
            </Group>
            <Group gap="xl">
                <Item style={{width: 120}}>
                    <SkeletonItem width={90} height={18}/>
                </Item>
                <SkeletonItem width={160} height={18}/>
            </Group>
        </Group>
        <Group className="pt-l">
            <SkeletonItem width={100} height={32}/>
            <SkeletonItem width={190} height={32}/>
        </Group>
    </FormSection>
);
